import { ChangedEntityType } from '../../models/change-log.model'
import { SingleDeviceType } from '../../models/single-device.model';

export function isChangeDevice(type: ChangedEntityType) {
    return Object.values(SingleDeviceType).includes(type as any);
}
